import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { OrderService } from 'src/app/services/order.service';
import { Order } from 'src/interfaces/order.model';
import { Waiter } from 'src/interfaces/waiter.model';

@Component({
    selector: 'app-menu-successpage',
    templateUrl: './menu-successpage.component.html',
    styleUrls: ['./menu-successpage.component.css'],
    standalone: false
})
export class MenuSuccessPageComponent implements OnInit {
  constructor(
    private router: Router,
  ) { }

  waiter: Waiter | null = null;
  paymentError: string | null = null;

  ngOnInit(): void {
    console.log('MenuSuccessPage | ngOnInit()');

    const waiterJson = sessionStorage.getItem('waiter');
    if (waiterJson) {
      try {
        this.waiter = JSON.parse(waiterJson) as Waiter;
        console.log('SuccessPageComponent | ngOnInit() | Waiter loaded:', this.waiter);
      } catch (error) {
        console.error('SuccessPageComponent | ngOnInit() | Error parsing waiter:', error);
        sessionStorage.removeItem('waiter');
      }
    } else {
      console.log('SuccessPageComponent | ngOnInit() | No waiter found in sessionStorage');
    }
  }

  ngOnDestroy(): void {
    sessionStorage.removeItem('waiter');
    console.log('SuccessPageComponent | ngOnDestroy() | Waiter removed from sessionStorage');
  }

  onImageError(event: Event): void {
    (event.target as HTMLImageElement).src = 'assets/no_photo_ru.png';
  }

  closePage(): void {
    this.router.navigate([`${window.location.pathname.replace('/success', '')}`]);
  }
}
